import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PanelComponent } from './panel.component';
import { AuthgaurdService} from '../../services/authgaurd/authgaurd.service';

const routes: Routes = [
  { path: 'panel',  component: PanelComponent, canActivate: [AuthgaurdService] },
  { path: 'panel/:id',  component: PanelComponent, canActivate: [AuthgaurdService] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PanelRoutingModule { }
